//Load posts
export const fetchPressBegin = () => ({
	type: 'FETCH_PRESS_BEGIN'
});

export const fetchPressSuccess = Press => ({
	type: 'FETCH_PRESS_SUCCESS',
	payload: Press
});

export const fetchPressError = error => ({
	type: 'FETCH_PRESS_FAILURE',
	payload: { error }
});

export function fetchPress() {
	return dispatch => {
		dispatch(fetchPressBegin());
		return fetch(process.env.REACT_APP_API_URL + process.env.REACT_APP_API_CUSTOM_PREFIX + 'press')
			.then(handleErrors)
			.then(res => res.json())
			.then(json => {
				dispatch(fetchPressSuccess(json));
			})
			.catch(error => dispatch(fetchPressError(error)));
	};
}


// Handle HTTP errors since fetch won't.
function handleErrors(response) {
	if (!response.ok) {
		throw Error(response.statusText);
	}
	return response;
}


// WEBPACK FOOTER //
// ./src/actions/pressActionCreators.js